const ApplicationsConfig = {
    SkillSearch: {
        backend: "https://skillsearch.ny.rga.com:9000",
        frontend: "https://skillsearch.ny.rga.com",
    },
};

export default ApplicationsConfig;
